import { useState, useEffect} from 'react';
import api from '../../../config.js';
import './entry.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaSearch, FaEye, FaArrowLeft, FaArrowRight, FaCog } from 'react-icons/fa';
import { makeSearch, getPermission, showMessageError, objectToURLParams } from '../../../classes/functions';
import { Link } from 'react-router-dom';
import ReactTooltip from "react-tooltip";
import PaginationPage from '../../../components/BasePage/Pagination/index.js';

export default function EntryDocuments(){
  const [list, setList] = useState([]);
  
  const [termSearch, setTermSearch] = useState('');
  const [typeSearch, setTypeSearch] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [itensByPage, setItensByPage] = useState(50);
  const [carrying, setCarrying] = useState(true);

  function getEntryDocuments(){
    const params = {
      page: page,
      limit: limit,
      propertySearch: typeSearch,
      termSearch: termSearch
    };
    
    api
    .get(`/api/entry_documents/getList?${objectToURLParams(params)}`)
    .then((response) => {
      setList(response.data);
    })
    .catch((error) => {
      console.log(error);
      
      if(error?.response?.data){
        showMessageError(error?.response?.data);
      };
    })
    .finally(() => {
      setCarrying(false);
    });
  }

  useEffect(()=> {
    getEntryDocuments();
  }, [ , termSearch, page, limit]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Entrada de Documentos">
          {getPermission('OPERACOES - ENTRADA DOCUMENTOS - CADASTRO') && <Link to="/entry_documents/cadastrar">
            <button className="buttonInsert">
              Cadastrar
            </button> 
          </Link>}
          <select className='selectQtdeItens' value={itensByPage} onChange={(e) => setLimit(e.target.value)}>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <select className='selectQtdeItens' value={typeSearch} onChange={(e) => setTypeSearch(e.target.value)}>
            <option value="">Documentos</option>
            <option value="Produto">Produto</option>
          </select>
          <input className="inputSearch" type="text" onChange={(e) => setTermSearch(e.target.value)} placeholder="Pesquisar"/>
          <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">Número Documento</th>
                <th scope="col">Série Documento</th>
                <th scope="col">Cliente/Fornecedor</th>
                <th scope="col">Observação</th>
                <th scope="col" className='collumOption'>Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="#">{item.numero_documento}</td>
                    <td data-label="Série Documento">{item.serie_documento}</td>
                    <td data-label="Nome Cliente">{item.cliente}</td>
                    <td data-label="Observação">{item.observacao}</td>
                    <td data-label="Opções">
                      {getPermission('OPERACOES - ENTRADA DOCUMENTOS - CADASTRO') && <Link className="action" to={`/entry_documents/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} />
                      </Link>}
                      <Link className="action" to={`/entry_documents/cadastrar/v${item.id}`} >
                        <FaEye color="#000" size={19} />
                      </Link>
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={5}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <PaginationPage page={page} setPage={setPage} limit={limit} />
      </div>}
    </div>
  )
}